import ShoppingCartOutlinedIcon from '@mui/icons-material/ShoppingCartOutlined';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FormattedMessage } from 'react-intl';
import { ExploreProducts } from '../../../components';

export const EmptyOrderDetails = () => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    borderRadius={4}
    marginY={2}
    border="1px solid #D6D6D6"
    sx={theme => ({
      height: '100%',
      [theme.breakpoints.up('tablet')]: {
        padding: theme.spacing(2),
      },
      [theme.breakpoints.down('tablet')]: {
        padding: theme.spacing(1),
      },
    })}
  >
    <Box
      borderRadius={16}
      display="flex"
      justifyContent="center"
      alignItems="center"
      alignContent="center"
      sx={theme => ({
        backgroundColor: '#F2F2FF',
        width: theme.spacing(8),
        height: theme.spacing(8),
      })}
    >
      <ShoppingCartOutlinedIcon
        sx={theme => ({
          height: theme.spacing(5),
          width: theme.spacing(5),
          color: '#5959EB',
        })}
      />
    </Box>
    <Box
      id="empty-order-not-found-title"
      key="empty-order-not-found-title"
      display="flex"
      alignContent="center"
      alignItems="center"
      justifyContent="center"
      paddingTop={1}
    >
      <Typography variant="h3" fontWeight={700}>
        <FormattedMessage id="page.order.history.order.not.found.title" />
      </Typography>
    </Box>
    <Box
      id="empty-order-not-found-desc"
      key="empty-order-not-found-desc"
      display="flex"
      alignContent="center"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      width="50%"
      minWidth={400}
    >
      <Typography variant="h5" color="textSecondary">
        <FormattedMessage id="page.order.history.order.not.found.desc" />
      </Typography>
    </Box>
    <Box
      id="empty-order-not-found-desc-explore-plan"
      key="empty-order-not-found-desc-explore-plan"
      display="flex"
      alignContent="center"
      alignItems="center"
      justifyContent="center"
      width="100%"
      paddingTop={2}
    >
      <ExploreProducts />
    </Box>
  </Box>
);
